var map = {
	"./adullact.png": 214,
	"./appropedia.png": 213,
	"./babytwit.png": 212,
	"./baikal.png": 211,
	"./bewelcome.png": 210,
	"./bitcoin.png": 209,
	"./blue-mind.png": 208,
	"./butter-popcorntime.png": 207,
	"./bw-rox.png": 206,
	"./caliopen.png": 205,
	"./camptocamp.png": 204,
	"./chatons.png": 203,
	"./cloudron.png": 202,
	"./conversations.png": 201,
	"./cops.png": 200,
	"./coquelicot.png": 199,
	"./covoiturage-libre.png": 198,
	"./cozy.png": 197,
	"./cumulusclips.png": 196,
	"./data-abulédu.png": 195,
	"./diaspora.png": 194,
	"./disconnect.png": 193,
	"./dogmazic.png": 192,
	"./dokuwiki.png": 191,
	"./dolomon.png": 190,
	"./duckduckgo.png": 189,
	"./dudle.png": 188,
	"./duniter.png": 187,
	"./ethercalc.png": 186,
	"./etherpad.png": 185,
	"./falkon.png": 184,
	"./fdn.png": 183,
	"./ffdn.png": 182,
	"./firefox.png": 181,
	"./framadate.png": 180,
	"./framaestro.png": 179,
	"./franciliens.net.png": 178,
	"./freshrss.png": 177,
	"./friendica.png": 176,
	"./gallica.png": 175,
	"./gitlab.png": 174,
	"./gnusocial.png": 173,
	"./grav.png": 172,
	"./hubl.in.png": 171,
	"./illyse.png": 170,
	"./indiehosters.png": 169,
	"./infini.png": 168,
	"./inventaire.png": 167,
	"./jamendo.png": 166,
	"./jami.png": 165,
	"./jirafeau.png": 164,
	"./jitsi-meet.png": 163,
	"./jitsi.png": 162,
	"./js-bin.png": 161,
	"./kallithea.png": 160,
	"./kaltura.png": 159,
	"./kanboard.png": 158,
	"./kiwix.png": 157,
	"./kmail.png": 156,
	"./kolab.png": 155,
	"./kyela.png": 154,
	"./la-mere-zaclys.png": 153,
	"./laverna.png": 152,
	"./ldn.png": 151,
	"./liberapay.png": 150,
	"./limeservice.png": 149,
	"./limesurvey.png": 148,
	"./liquidfeedback.png": 147,
	"./litecoin.png": 146,
	"./loomio.png": 145,
	"./lstu.png": 144,
	"./lufi.png": 143,
	"./lutim.png": 142,
	"./lychee.png": 141,
	"./mailman.png": 140,
	"./mailoo.png": 139,
	"./mastodon.png": 138,
	"./matomo-piwik.png": 137,
	"./matrix.png": 136,
	"./mattermost.png": 135,
	"./mediadrop.png": 134,
	"./mediagoblin.png": 133,
	"./mediawiki.png": 132,
	"./midori.png": 131,
	"./mindmup.png": 130,
	"./minetest.png": 129,
	"./miniflux.png": 128,
	"./mixmail.png": 127,
	"./movim.png": 126,
	"./neutrinet.png": 125,
	"./nextcloud.png": 124,
	"./okawix.png": 123,
	"./open-web-analytics.png": 122,
	"./openclipart.png": 121,
	"./openstreetmap.png": 120,
	"./ouvaton.png": 119,
	"./ownstagram.png": 118,
	"./peertube.png": 117,
	"./php-list.png": 116,
	"./piwigo.png": 115,
	"./plumi.png": 114,
	"./pluxml.png": 113,
	"./pods-diaspora.png": 112,
	"./pods-movim.png": 111,
	"./pootle.png": 110,
	"./privatebin.png": 109,
	"./protonmail.png": 108,
	"./pump.io.png": 107,
	"./pyd.io.png": 106,
	"./qwant.png": 105,
	"./rainloop.png": 104,
	"./rhien.png": 103,
	"./ring.png": 102,
	"./riseup.png": 101,
	"./rizzoma.png": 100,
	"./rocket.chat.png": 99,
	"./rosetta-launchpad.png": 98,
	"./roundcube.png": 97,
	"./salut-a-toi.png": 96,
	"./sandstorm.png": 95,
	"./savannah.png": 94,
	"./seacloud.png": 93,
	"./seafile.png": 92,
	"./searx.png": 91,
	"./seeks.png": 90,
	"./shaarli.png": 89,
	"./signal.png": 88,
	"./silence.png": 87,
	"./spip.png": 86,
	"./startpage-ixquick.png": 85,
	"./strut.png": 84,
	"./sud-ouest.png": 83,
	"./svg-edit.png": 82,
	"./sylpheed.png": 81,
	"./sympa.png": 80,
	"./tagspaces.png": 79,
	"./thunderbird--enigmail.png": 78,
	"./tinytinyrss.png": 77,
	"./toile-libre.png": 76,
	"./tor-birdy.png": 75,
	"./tor-browser.png": 74,
	"./tox.png": 73,
	"./trustroots.png": 72,
	"./turtl.png": 71,
	"./tutanota.png": 70,
	"./tuxfamily.png": 69,
	"./twister.png": 68,
	"./umap.png": 67,
	"./vikidia.png": 66,
	"./vroom.im.png": 65,
	"./wallabag.png": 64,
	"./webcalendar.png": 63,
	"./webform.png": 62,
	"./wekan.png": 61,
	"./wethepeople.png": 60,
	"./wikimedia-commons.png": 59,
	"./wikipedia.png": 58,
	"./wikisource.png": 57,
	"./wikivoyage.png": 56,
	"./wire.png": 55,
	"./wisemapping.png": 54,
	"./wordpress.png": 53,
	"./yacy.png": 52,
	"./yourls.png": 51,
	"./yunohost.png": 50,
	"./zanata.png": 49,
	"./zenphoto.png": 48,
	"./zk-calendar.png": 47,
	"./zk-spreadsheet.png": 46
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 215;